import { Alert, Box, Button, CircularProgress } from '@mui/material'
import { observer } from 'mobx-react-lite'
import Payment from '../components/payments/Payment'
import SubscriptionInfo from '../components/payments/SubscriptionInfo'
import entitlementStore from '../stores/entitlementStore'

const PaymentPage = observer(() => (
	<Box className='p-4'>
		{entitlementStore.status === 'loading' && <CircularProgress size={24} />}
		{entitlementStore.status === 'error' && (
			<Alert
				severity='error'
				action={(
					<Button color='inherit' size='small' onClick={() => entitlementStore.fetch({ force: true })}>
						Повторить
					</Button>
				)}
			>
				Не удалось загрузить актуальные права доступа ({entitlementStore.errorCode}).
			</Alert>
		)}
		{entitlementStore.data && <SubscriptionInfo entitlements={entitlementStore.data} />}
		<Payment />
	</Box>
))

export default PaymentPage
